import * as accountService from '/source/js/services/accountService';
import { showAlerts, clearAlerts } from '/source/_patterns/01-components/footermodal/footermodal';
import { showSpinner, hideSpinner } from '/source/_patterns/01-components/spinner/spinner';

const DD_SELECTED = 'select-box__selected';
const DD_FOCUSED = 'select-dropdown__is-focused';
const CURR_REGION = $("input[name='Region']:checked").val();
const CURR_ORDERSUBTYPE = $("input[name='chooseCatalog']:checked").val();
const CURR_ORDERTYPE = $('input[name="OrderSelection"]:checked').prop('id');
const GUEST_ORDER_TYPE = 'GuestOrder';
const WHOLESALE_ORDER_TYPE = 'WholesaleOrder';
const SUBSCRIPTION_ORDER_TYPE = 'SubscriptionOrder';
const ASSISTED_ENROLLMENT_ORDER_TYPE = 'AssistedEnrollmentOrder';
const RECOMMENDED_CART_ORDER_TYPE = 'RecommendedCartOrder';
const EDIT_RECOMMENDED_CART_ORDER_TYPE = 'EditRecommendedCartOrder';
const INDIVIDUAL_LINK_ORDER_TYPE = 'IndividualLink';
const BUNDLE_LINK_ORDER_TYPE = 'BundleLink';
const EDIT_BUNDLE_LINK_ORDER_TYPE = 'EditBundleLink';
const NFR_ORDER_SUBTYPE = 'NFR';
let onLoadSelectedOrderType;
let catalogSelectorData;
let bpLinkHiddenField;
let bpBundleHiddenField;
let isGuestCheckout;
let isBPShareLinkFlow;
let isBPBundleFlow;
let isSubscriptionOrderOnLoad = false;

function selectRadio() {
    let $radioInput = $("input[name='chooseCatalog']");

    $radioInput.click(function (e) {
        e.stopPropagation();
        let $this = $(this);
        if($radioInput.is(':checked')) {
            $radioInput.prop('checked', false);
            $this.prop('checked', true);
        }
        if($this.is(':checked')) {
            showClearAlerts(null, $this.val());
        }
    });
}

function showClearAlerts(selectedRegion, selectedOrderSubType) {
    var currCartItems = document.getElementById('hidden-cartItem-count');
    if(!selectedOrderSubType) {
        selectedOrderSubType = $("input[name='chooseCatalog']:checked").val();
    }

    if(!selectedRegion) {
        selectedRegion = $("input[name='Region']:checked").val();
    }
    if((CURR_ORDERSUBTYPE !== selectedOrderSubType || CURR_REGION !== selectedRegion) &&
        currCartItems && currCartItems.value > 0) {
        if($('input[name="OrderSelection"]:checked').prop('id') === WHOLESALE_ORDER_TYPE) {
            if(catalogSelectorData.IsCurrentContextWholesale) {
                showAlerts();
            } else {
                clearAlerts();
            }
        } else {
            showAlerts();
        }
    } else {
        const selectedOrderType = $('input[name="OrderSelection"]:checked').prop('id');
        const isRCFlow = $('#hidden-isRecommendedCartFlow').val() === 'true';
        const isRCCreateFlow = $('#hidden-isRecommendedCartCreate').val() === 'true';
        if(!(selectedOrderType !== CURR_ORDERTYPE && isRCFlow && !isRCCreateFlow) || !isRCFlow) {
            clearAlerts();
        }
    }
    if(selectedRegion === null) {
        handleOrderTypeChange(null);
    }
}

function countryDropDown() {
    // let $selectButton = $('.select-box');
    let $ddContainer = $('.select-dropdown');
    let $ddList = $('.select-box__list');
    let $ddSelection = $('.select-box__option');
    let $ddCurrent = $('.select-box__current');

    function openDropdown() {
        $ddList.show();
        $ddContainer.addClass(DD_FOCUSED);
        $ddContainer.attr('aria-expanded', 'true');
    }

    function closeDropdown() {
        $ddList.hide();
        $ddContainer.removeClass(DD_FOCUSED);
        $ddContainer.attr('aria-expanded', 'false');
    }

    $ddContainer.click(function () {
        if($ddList.is(':hidden')) {
            openDropdown();
            return false;
        } else {
            closeDropdown();
        }
    });

    $(document).click(function () {
        closeDropdown();
    });

    $ddList.click(function (e) {
        $ddContainer.addClass(DD_FOCUSED);
        e.stopPropagation();
    });

    // Keyboard support for the dropdown
    $ddCurrent.on('keydown', function (e) {
        let key = e.which || e.keyCode;
        // Enter or Space
        if(key === 13 || key === 32) {
            e.preventDefault();
            if($ddList.is(':hidden')) {
                openDropdown();
                $ddSelection.filter('.' + DD_SELECTED).focus();
            } else {
                closeDropdown();
            }
        }
        // Escape
        if(key === 27) {
            closeDropdown();
            $ddCurrent.focus();
        }
        // Arrow Down
        if(key === 40) {
            e.preventDefault();
            if($ddList.is(':hidden')) {
                openDropdown();
            }
            let $visible = $ddSelection.filter(':visible');
            let $focused = $visible.filter('.' + DD_SELECTED);
            let idx = $visible.index($focused);
            if(idx < $visible.length - 1) {
                $visible.eq(idx + 1).focus();
            }
        }
        // Arrow Up
        if(key === 38) {
            e.preventDefault();
            let $visible = $ddSelection.filter(':visible');
            let $focused = $visible.filter('.' + DD_SELECTED);
            let idx = $visible.index($focused);
            if(idx > 0) {
                $visible.eq(idx - 1).focus();
            }
        }
    });

    $ddSelection.attr('tabindex', '-1');
    $ddSelection.on('keydown', function (e) {
        let key = e.which || e.keyCode;
        let $visible = $ddSelection.filter(':visible');
        let idx = $visible.index($(this));
        // Arrow Down
        if(key === 40) {
            e.preventDefault();
            if(idx < $visible.length - 1) {
                $visible.eq(idx + 1).focus();
            }
        }
        // Arrow Up
        if(key === 38) {
            e.preventDefault();
            if(idx > 0) {
                $visible.eq(idx - 1).focus();
            }
        }
        // Enter or Space - select item
        if(key === 13 || key === 32) {
            e.preventDefault();
            $(this).click();
            closeDropdown();
            $ddCurrent.focus();
        }
        // Escape - close dropdown
        if(key === 27) {
            closeDropdown();
            $ddCurrent.focus();
        }
    });

    $ddSelection.click(function () {
        let $this = $(this);
        $ddSelection.removeClass(DD_SELECTED);
        $this.addClass(DD_SELECTED);
        // Update aria-selected on listbox items
        $ddList.find('[role="option"]').attr('aria-selected', 'false');
        $this.closest('[role="option"]').attr('aria-selected', 'true');
        $('.alert--country').show();
        let dropdownCountrySelected = $(this).attr('value');
        $('div.countrySelectionDropdown input[name="Region"]').each(function () {
            if($(this).val() !== dropdownCountrySelected) {
                $(this).prop('checked', false);
            } else {
                $(this).prop('checked', true);
            }
        });
        handleCountryChange(dropdownCountrySelected);
        checkForRcBetaFeatureToggle();
        if(CURR_REGION === dropdownCountrySelected) {
            const isRCFlow = $('#hidden-isRecommendedCartFlow').val() === 'true';
            const isRCCreateFlow = $('#hidden-isRecommendedCartCreate').val() === 'true';
            const selectedOrderType = $('input[name="OrderSelection"]:checked').prop('id');
            if(isRCCreateFlow) {
                if(selectedOrderType === CURR_ORDERTYPE) {
                    $('.alert--country').hide();
                }
            } else if(!isRCFlow) {
                $('.alert--country').hide();
            }
        }
    });
}

function showChangeCatalogOrRegionMessage() {
    var currCartItems = document.getElementById('hidden-cartItem-count');
    const hasAnythingInCart = currCartItems && currCartItems.value > 0;
    let region = $("input[name='Region']:checked").val();
    let selectedOrderType = $('input[name="OrderSelection"]:checked').prop('id');
    if(hasAnythingInCart && onLoadSelectedOrderType && onLoadSelectedOrderType.length) {
        if(onLoadSelectedOrderType !== selectedOrderType || region !== CURR_REGION) {
            $('.alert--country').show();
        } else {
            $('.alert--country').hide();
        }
    }
}

function filterOrderSubTypes(currentMarket, selectedOrderType) {
    let currentCountryOrderSubTypes = currentMarket[0].OrderTypes;

    if(currentCountryOrderSubTypes.length > 1 && (selectedOrderType === BUNDLE_LINK_ORDER_TYPE || selectedOrderType === EDIT_BUNDLE_LINK_ORDER_TYPE || selectedOrderType === INDIVIDUAL_LINK_ORDER_TYPE)) {
        currentCountryOrderSubTypes = new Array(currentCountryOrderSubTypes[0]);
    }

    return currentCountryOrderSubTypes;
}

function forceCountryToMemberCountry() {
    var currentMemberCountry = $('#marketCurrentCountry').val();
    $('.select-box__option').removeClass(DD_SELECTED);
    $('input[class=select-box__input]').prop('checked', false);
    $('label[class=select-box__option][value=' + currentMemberCountry + ']').addClass(DD_SELECTED);
    $('input[class=select-box__input][value=' + currentMemberCountry + ']').prop('checked', true);
    var selectedRegion = $("input[name='Region']:checked").val();
    handleCountryChangeOrderType(selectedRegion, true);
}

function handleOrderTypeChange(data) {
    let isExpiredMembership = $('#hidden-isExpired-membership').val();
    let $nfrOption = $('#OrderSubTypeRadioNFR');
    let region = $("input[name='Region']:checked").val();
    $('.countrySelectionDropdown').show();
    $('[data-hideforsubscription="True"]').show();
    $('[data-hide-for-orders="True"]').hide();
    $('[data-hide-for-orders="False"]').show();
    $('.countrySelectionDropdown.subscriptionCountrySelectionDropdown').hide();
    $('.orderSubTypeSelection').show();
    $('.cancel-subscription-text').hide();

    handleCountryChangeAfterFtCheck(region, true);

    const currCartItems = document.getElementById('hidden-cartItem-count');
    const cartHasItems = currCartItems && currCartItems.value > 0;

    const isRCFlow = $('#hidden-isRecommendedCartFlow').val() === 'true';
    const isRCCreateFlow = $('#hidden-isRecommendedCartCreate').val() === 'true';
    const isRCEditFlow = $('#hidden-isRecommendedCartEdit').val() === 'true';
    const selectedOrderSubType = $("input[name='chooseCatalog']:checked").val();
    const isBpBundleEditFlow = $('#hidden-isEditBPBundleLinksFlow').val() === 'true';

    if(typeof data === 'string') {
        region = data;
    }

    if(isBPShareLinkFlow) {
        $('[data-hide-for-bp-links="True"]').hide();
    }

    if(isBPBundleFlow) {
        $('[data-hide-for-bp-bundle="True"]').hide();
    }

    let allowedMarketsForUser;
    if(catalogSelectorData && catalogSelectorData.AllowedMarketsForUser) {
        allowedMarketsForUser = catalogSelectorData.AllowedMarketsForUser;
    }

    let selectedOrderType = $('input[name="OrderSelection"]:checked').prop('id');

    if(isRCEditFlow) {
        if(selectedOrderType !== EDIT_RECOMMENDED_CART_ORDER_TYPE) {
            $('.countrySelectionDropdown').show();
        } else {
            $('.countrySelectionDropdown').hide();
        }
    }

    if(isBpBundleEditFlow) {
        if(selectedOrderType !== EDIT_BUNDLE_LINK_ORDER_TYPE) {
            $('.countrySelectionDropdown').show();
        } else {
            $('.countrySelectionDropdown').hide();
        }
    }

    if(selectedOrderType === GUEST_ORDER_TYPE && !isGuestCheckout) {
        if(allowedMarketsForUser) {
            let currentMarket = allowedMarketsForUser.filter(m => m.Value === region);
            $nfrOption.parent().hide();
            if(currentMarket[0].DefaultOrderSubtype === NFR_ORDER_SUBTYPE) {
                $nfrOption.parent().show();
                $nfrOption.prop('checked', true);
            } else {
                $('#OrderSubTypeRadioOTG').prop('checked', true);
            }
        }
        if(currCartItems && currCartItems.value > 0) {
            if(region === CURR_REGION) {
                if(isRCCreateFlow) {
                    if(selectedOrderType === CURR_ORDERTYPE) {
                        $('.alert--country').hide();
                    } else {
                        $('.alert--country').show();
                    }
                } else {
                    // in purchase RC flow, show alert
                    if(isRCFlow) {
                        $('.alert--country').show();
                    } else {
                        $('.alert--country').hide();
                    }
                }
                $('.alert--orderType').show();
            } else {
                // regardless of flow, show alert
                $('.alert--country').show();
                $('.alert--orderType').hide();
            }
        }
    } else if(selectedOrderType === INDIVIDUAL_LINK_ORDER_TYPE) {
        $('[data-hide-for-orders="True"]').show();
        $('[data-hide-for-bp-links="True"]').hide();
        if(cartHasItems) {
            if(bpLinkHiddenField.val() === 'true') {
                $('.alert--country').hide();
            } else {
                $('.alert--country').show();
            }
        } else {
            $('.alert--country').hide();
        }
    } else if(selectedOrderType === BUNDLE_LINK_ORDER_TYPE) {
        $('[data-hide-for-orders="True"]').show();
        $('[data-hide-for-bp-bundle="True"]').hide();
        if(cartHasItems) {
            if(bpBundleHiddenField.val() === 'true' && region === CURR_REGION) {
                $('.alert--country').hide();
            } else {
                $('.alert--country').show();
            }
        } else {
            $('.alert--country').hide();
        }
    } else if(selectedOrderType === SUBSCRIPTION_ORDER_TYPE) {
        showChangeCatalogOrRegionMessage();
        const subscriptionFlowSubtype = $('[data-subscriptionflowsubtype="Setup"]');
        if(subscriptionFlowSubtype !== null && subscriptionFlowSubtype !== undefined && subscriptionFlowSubtype.length > 0) {
            $('.countrySelectionDropdown').show();
            $('[data-hideforsubscription="True"]').hide();
            if($(this).attr('class') === 'order-radio__input') {
                if(!isSubscriptionOrderOnLoad) {
                    isSubscriptionOrderOnLoad = false;
                    forceCountryToMemberCountry();
                } else {
                    enforceAllowedMarketSelectionForUser();
                }
            }

            showChangeCatalogOrRegionMessage();
            return;
        } else {
            $('.countrySelectionDropdown').hide();
            $('.orderSubTypeSelection').hide();
            if(!isRCCreateFlow) {
                $('.alert--country').hide();
            } else {
                $('.alert--country').show();
            }
            $('.cancel-subscription-text').show();
        }

        $('.alert--orderType').hide();
    } else if(selectedOrderType === WHOLESALE_ORDER_TYPE && isExpiredMembership === 'true') {
        showChangeCatalogOrRegionMessage();
        // hide everything below OrderType selection
        $('.countrySelectionDropdown').hide();
        $('.orderSubTypeSelection').hide();
        $('.alert--country').hide();
        $('.alert--orderType').hide();
    } else {
        showChangeCatalogOrRegionMessage();
        $('.alert--orderType').hide();
        if(currCartItems && currCartItems.value > 0) {
            // Applies for Create/Edit/Purchase RC flows
            if(isRCFlow) {
                if(region !== CURR_REGION || selectedOrderType !== CURR_ORDERTYPE || selectedOrderSubType !== CURR_ORDERSUBTYPE) {
                    $('.alert--country').show();
                } else {
                    $('.alert--country').hide();
                }
            }
        }
    }

    if(selectedOrderType !== EDIT_BUNDLE_LINK_ORDER_TYPE && isBpBundleEditFlow) {
        $('.alert--country').show();
    }
    // sanity check
    if($('#catalogSelectorModal').is(':visible') && $("input[name='Region']:checked").parent().is(':hidden')) {
        forceCountryToMemberCountry();
    }

    if(allowedMarketsForUser) {
        let currentMarket = allowedMarketsForUser.filter(m => m.Value === region);
        let currentCountryCode = currentMarket.length > 0 ? currentMarket[0].Value.toLowerCase() : '';
        if(currentCountryCode !== '' && currentCountryCode !== 'us' && currentCountryCode !== 'ca' && currentCountryCode !== 'pr' && currentCountryCode !== 'mx') {
            if(filterOrderSubTypes(currentMarket, selectedOrderType).map(i => i.OrderSubTypeShortName).includes(NFR_ORDER_SUBTYPE)) {
                $nfrOption.parent().show();
            } else {
                $nfrOption.parent().hide();
            }
        }
    }
}

$('#SubmitCatalogChangeButton').click(async function () {
    let region = $("input[name='Region']:checked").val();
    let flowOrderType = $('input[name="OrderSelection"]:checked').prop('id');
    let selectedOrderSubType = '';
    selectedOrderSubType = $("input[name='chooseCatalog']:checked").val();
    if(flowOrderType === onLoadSelectedOrderType && region === CURR_REGION && selectedOrderSubType === CURR_ORDERSUBTYPE) {
        // didn't change anything
        console.log("didn't change anything");
        $('#catalogSelectorModal').modal('hide');
        return;
    }

    showSpinner('Changing catalog started');
    if(flowOrderType !== ASSISTED_ENROLLMENT_ORDER_TYPE &&
        flowOrderType !== RECOMMENDED_CART_ORDER_TYPE &&
        region === CURR_REGION && !isGuestCheckout &&
        selectedOrderSubType === CURR_ORDERSUBTYPE &&
        flowOrderType !== GUEST_ORDER_TYPE &&
        flowOrderType !== SUBSCRIPTION_ORDER_TYPE &&
        flowOrderType !== INDIVIDUAL_LINK_ORDER_TYPE &&
        flowOrderType !== BUNDLE_LINK_ORDER_TYPE) {
        if(flowOrderType === WHOLESALE_ORDER_TYPE) {
            if(catalogSelectorData.IsCurrentContextWholesale) {
                hideSpinner('Changing catalog completed');
                $('#catalogSelectorModal').modal('hide');
                return;
            }
        } else {
            hideSpinner('Changing catalog completed');
            $('#catalogSelectorModal').modal('hide');
            return;
        }
    }

    if(flowOrderType === onLoadSelectedOrderType && region === CURR_REGION) {
        if(flowOrderType === BUNDLE_LINK_ORDER_TYPE || flowOrderType === INDIVIDUAL_LINK_ORDER_TYPE) {
            hideSpinner('Changing catalog completed');
            $('#catalogSelectorModal').modal('hide');
            return;
        }
    }

    if(flowOrderType === WHOLESALE_ORDER_TYPE && catalogSelectorData.PreventFromPlacingMoreThan1OrderIn7Days) {
        hideSpinner('Changing catalog completed');
        $('#catalogSelectorModal').modal('hide');
        return;
    }

    let isExpiredMembership = $('#hidden-isExpired-membership').val();
    if(flowOrderType === WHOLESALE_ORDER_TYPE && isExpiredMembership === 'true') {
        region = $('#hidden-residence-Country').val();
    }

    let contextItemID = $('#hidden-context-item').val();
    let request = {
        region: region,
        orderSubType: selectedOrderSubType,
        itemID: contextItemID,
        flowOrderType: flowOrderType
    };

    if(flowOrderType === SUBSCRIPTION_ORDER_TYPE) {
        let $subscriptionOrderButton = $('.subscriptionOrderOption');
        if($subscriptionOrderButton.length > 0) {
            request.FlowOrderSubType = $subscriptionOrderButton.data('subscriptionflowsubtype');
        }
    }

    try {
        if(flowOrderType === WHOLESALE_ORDER_TYPE) {
            var response = await accountService.SetUpContext();
            console.log('SetUpContext:', response);
        }
        const result = await accountService.changeCatalog(request);
        if(result) {
            $('#catalogSelectorModal').modal('hide');
            $('#catalogSelectorModal').on('hide.bs.modal', () => hideSpinner('Changing catalog completed'));
            window.location = result;
        }
    } catch (error) {
        hideSpinner('Changing catalog failed');
        console.error('ChangeCatalog failed:', error.status, error.statusText);
        if(error.status === 403) {
            window.location.reload();
        }
    }
});

function clearLocalFields() {
    if(!isGuestCheckout) {
        $('#EnrollOrder').prop('checked', true);
    } else {
        $('#GuestOrder').prop('checked', true);
    }
    $(`input[name="Region"][value="${CURR_REGION}"]`).click();
    handleCountryChange(CURR_REGION);
    clearAlerts();
}

function initEventHandlers() {
    let $catalogSelector = $('.catalogSelectorModal');
    catalogSelectorData = $catalogSelector.data('catalog-selector');
    if(!catalogSelectorData) { return; }
    bpLinkHiddenField = $('#hidden-isBPIndividualLinksFlow');
    bpBundleHiddenField = $('#hidden-isBPBundleLinksFlow');
    isGuestCheckout = $('#hidden-isGuestCheckout').val() === 'true';
    isBPShareLinkFlow = $('#hidden-isBPShareLinkFlow').val() === 'true';
    isBPBundleFlow = $(bpBundleHiddenField).val() === 'true';
    countryDropDown();
    clearAlerts();
    $('.close').on('click', clearLocalFields);
    $('.btn-closeModal').on('click', clearLocalFields);
    $("input[name='chooseCatalog']").on('click', selectRadio);
    $('input[name="OrderSelection"]').on('change', handleOrderTypeChange);
    $('input[name="OrderSelection"]').on('change', checkForRcBetaFeatureToggle);

    // Keep sub-type radio inputs out of Tab order (they are opacity:0)
    // Instead, make the visible labels tabbable
    $('.promotion-ribbon-modal').find('.custom-radio .custom-control-input').attr('tabindex', '-1');

    // Keyboard activation for order-type radio labels
    $('.order-radio__label[tabindex]').on('keydown', function(e) {
        if(e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).find('input[type="radio"]').prop('checked', true).trigger('change');
            $(this).click();
        }
    });

    // Keyboard activation for sub-type radio labels (OTG/NFR)
    $('.promotion-ribbon-modal').find('.custom-control-label').on('keydown', function(e) {
        if(e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            let inputId = $(this).attr('for');
            $('#' + inputId).prop('checked', true).trigger('click');
        }
    });
    let isInBPFlows = $(bpLinkHiddenField).val() === 'true' || $(bpBundleHiddenField).val() === 'true';
    let $subscriptionOrderButton = $('.subscriptionOrderButton');
    if($subscriptionOrderButton.length > 0 && !catalogSelectorData.IsCurrentContextWholesale && !isInBPFlows) {
        isSubscriptionOrderOnLoad = true;
        $(`#${SUBSCRIPTION_ORDER_TYPE}`).click();
    }

    if(isInBPFlows) {
        $('[data-hide-for-orders="True"]').show();
    } else {
        $('[data-hide-for-orders="True"]').hide();
    }

    onLoadSelectedOrderType = $('input[name="OrderSelection"]:checked').prop('id');
    updateUIEditRCFlow();
    updateUIEditBpBundleFlow();
}

function updateUIEditRCFlow() {
    const isRCEditFlow = $('#hidden-isRecommendedCartEdit').val();
    if(isRCEditFlow === 'true') {
        $('.countrySelectionDropdown').hide();
    }
}

function updateUIEditBpBundleFlow() {
    const isBpBundleEditFlow = $('#hidden-isEditBPBundleLinksFlow').val();
    if(isBpBundleEditFlow === 'true') {
        $('.countrySelectionDropdown').hide();
    }
}

$(function () {
    initEventHandlers();
    var currentCountry = $("input[name='Region']:checked").val();
    handleCountryChange(currentCountry);
    handleOrderTypeChange(currentCountry, true);
});

function handleCountryChange(currentCountryRadioValue) {
    $('[id ^= OrderSubTypeRadio]').each(function () {
        $(this).parent().hide();
    });

    var guestOrderOption = $(".order-radio label[for='GuestOrder']");
    var markets = $('.order-radio').data('afi-markets');
    if(markets) {
        var marketsList = markets.split(',');
    }
    if(marketsList && currentCountryRadioValue && marketsList.includes(currentCountryRadioValue.toUpperCase())) {
        guestOrderOption.hide();
    } else {
        guestOrderOption.show();
    }

    handleCountryChangeAfterFtCheck(currentCountryRadioValue, true);
    showChangeCatalogOrRegionMessage();
    showHideBPProgramPills(currentCountryRadioValue);
}

function showHideBPProgramPills(country) {
    let selectedCountryDiv = $(`.countrySelectionDropdown .select-box__value input[type="radio"][value="${country}"]`).closest('.select-box__value');
    let hideForBpLinks = selectedCountryDiv.data('hide-for-bp-links');
    let hideForBpBundle = selectedCountryDiv.data('hide-for-bp-bundle');
    let bpProgramDiv = $('div.order-radio .brand-partner-program');
    if($(bpProgramDiv).length) {
        if(hideForBpLinks === 'True' && hideForBpBundle === 'True') {
            $(bpProgramDiv).hide();
        } else {
            $(bpProgramDiv).show();
            if(hideForBpLinks === 'True') {
                $('label[for="IndividualLink"]').hide();
            } else {
                $('label[for="IndividualLink"]').show();
            }

            if(hideForBpBundle === 'True') {
                $('label[for="BundleLink"]').hide();
            } else {
                $('label[for="BundleLink"]').show();
            }
        }
    }
}

function enforceAllowedMarketSelectionForUser() {
    $('.select-box__option').removeClass(DD_SELECTED);
    $('input[class=select-box__input]').prop('checked', false);
    $('label[class=select-box__option][value=' + CURR_REGION + ']').addClass(DD_SELECTED);
    $('input[class=select-box__input][value=' + CURR_REGION + ']').prop('checked', true);
    var selectedRegion = $("input[name='Region']:checked").val();
    handleCountryChangeOrderType(selectedRegion, true);
}

function handleCountryChangeOrderType(currentCountryRadioValue, showRadio) {
    $('[id ^= OrderSubTypeRadio]').each(function () {
        $(this).parent().hide();
    });
    let currentCountrySupportedOrderSubTypes;
    let currentCountryOrderSubTypes;
    let currentMarket;
    let currentDefaultOrderSubtype;
    let $catalogSelector = $('.catalogSelectorModal');
    catalogSelectorData = $catalogSelector.data('catalog-selector');
    let allowedMarketsForUser;
    if(catalogSelectorData && catalogSelectorData.AllowedMarketsForUser) {
        allowedMarketsForUser = catalogSelectorData.AllowedMarketsForUser;
    }
    if(allowedMarketsForUser) {
        currentMarket = allowedMarketsForUser.filter(m => m.Value === currentCountryRadioValue);
    }
    if(currentMarket && currentMarket.length > 0 && currentMarket[0].OrderTypes) {
        let selectedOrderType = $('input[name="OrderSelection"]:checked').prop('id');
        currentCountryOrderSubTypes = filterOrderSubTypes(currentMarket, selectedOrderType);
        currentCountrySupportedOrderSubTypes = currentCountryOrderSubTypes.map(i => i.OrderSubTypeShortName);

        let selectedCurrOrderSubType = currentCountryOrderSubTypes.find(x => x.OrderSubTypeShortName === CURR_ORDERSUBTYPE);
        if(selectedCurrOrderSubType !== undefined) { // If selected order subtype is one of the supported order subtype for market
            currentDefaultOrderSubtype = CURR_ORDERSUBTYPE;
        } else { // Set selected order sub type as default order sub type
            currentDefaultOrderSubtype = currentMarket[0].DefaultOrderSubtype;
        }
    }
    if(currentDefaultOrderSubtype) {
        let $orderSubTypeRadio = $('#OrderSubTypeRadio' + currentDefaultOrderSubtype);
        if(showRadio) {
            $orderSubTypeRadio.parent().show();

            if(currentCountrySupportedOrderSubTypes.length > 1) {
                $('.promotion-ribbon-modal').find('.custom-radio').removeClass('hideRadio');
                $('.promotion-ribbon-modal').find('.custom-radio').show();
                $('.promotion-ribbon-modal').find('.custom-radio .custom-control-label').attr('tabindex', '0');
            } else {
                $('.promotion-ribbon-modal').find('.custom-radio').addClass('hideRadio');
                $('.promotion-ribbon-modal').find('.custom-radio .custom-control-label').attr('tabindex', '-1');
            }
        }
        $orderSubTypeRadio.trigger('click');
        for (let j = 0; j < currentCountryOrderSubTypes.length; j++) {
            let $subTypeDiv = $('#OrderSubTypeRadio' + currentCountryOrderSubTypes[j].OrderSubTypeShortName).parent();
            $subTypeDiv.find('p').text(currentCountryOrderSubTypes[j].OrderSubTypeDescription);
            $subTypeDiv.find('strong').text(currentCountryOrderSubTypes[j].OrderSubTypeDisplayName);
        }
    }
}

function handleCountryChangeAfterFtCheck(currentCountryRadioValue, showRadio, isFirstLoad) {
    var allOrderSubTypeElements = document.querySelectorAll('[id^=OrderSubTypeRadio]');
    let currentCountrySupportedOrderSubTypes;
    let currentCountryOrderSubTypes;
    let currentMarket;
    let currentDefaultOrderSubtype;
    let $catalogSelector = $('.catalogSelectorModal');
    catalogSelectorData = $catalogSelector.data('catalog-selector');

    let allowedMarketsForUser;
    if(catalogSelectorData && catalogSelectorData.AllowedMarketsForUser) {
        allowedMarketsForUser = catalogSelectorData.AllowedMarketsForUser;
    }

    if(allowedMarketsForUser) {
        currentMarket = allowedMarketsForUser.filter(m => m.Value === currentCountryRadioValue);
    }
    if(currentMarket && currentMarket.length > 0 && currentMarket[0].OrderTypes) {
        let selectedOrderType = $('input[name="OrderSelection"]:checked').prop('id');
        currentCountryOrderSubTypes = filterOrderSubTypes(currentMarket, selectedOrderType);
        currentCountrySupportedOrderSubTypes = currentCountryOrderSubTypes.map(i => i.OrderSubTypeShortName);

        let selectedCurrOrderSubType = currentCountryOrderSubTypes.find(x => x.OrderSubTypeShortName === CURR_ORDERSUBTYPE);
        if(selectedCurrOrderSubType !== undefined) { // If selected order subtype is one of the supported order subtype for market
            currentDefaultOrderSubtype = CURR_ORDERSUBTYPE;
        } else { // Set selected order sub type as default order sub type
            currentDefaultOrderSubtype = currentMarket[0].DefaultOrderSubtype;
        }
    }

    let defaultOrderSubTypeSelected = false;

    if(currentDefaultOrderSubtype) {
        let $orderSubTypeRadio = $('#OrderSubTypeRadio' + currentDefaultOrderSubtype);
        if(showRadio) {
            $orderSubTypeRadio.parent().show();

            if(currentCountrySupportedOrderSubTypes.length > 1) {
                $('.promotion-ribbon-modal').find('.custom-radio').removeClass('hideRadio');
                $('.promotion-ribbon-modal').find('.custom-radio').show();
                $('.promotion-ribbon-modal').find('.custom-radio .custom-control-label').attr('tabindex', '0');
            } else {
                $('.promotion-ribbon-modal').find('.custom-radio').addClass('hideRadio');
                $('.promotion-ribbon-modal').find('.custom-radio .custom-control-label').attr('tabindex', '-1');
            }
        }
        $orderSubTypeRadio.trigger('click');
        showClearAlerts(currentCountryRadioValue, currentDefaultOrderSubtype);
        for (let j = 0; j < currentCountryOrderSubTypes.length; j++) {
            let $subTypeDiv = $('#OrderSubTypeRadio' + currentCountryOrderSubTypes[j].OrderSubTypeShortName).parent();
            $subTypeDiv.find('p').text(currentCountryOrderSubTypes[j].OrderSubTypeDescription);
            $subTypeDiv.find('strong').text(currentCountryOrderSubTypes[j].OrderSubTypeDisplayName);
        }
    } else {
        defaultOrderSubTypeSelected = true;
        if(currentCountrySupportedOrderSubTypes && currentCountrySupportedOrderSubTypes.length > 0) {
            for (var i = 0; i < allOrderSubTypeElements.length; i++) {
                if(currentCountrySupportedOrderSubTypes.includes(allOrderSubTypeElements[i].value)) {
                    let $orderSubTypeRadio = $('#OrderSubTypeRadio' + allOrderSubTypeElements[i].value);
                    let currentCountryOrderSubType = currentCountryOrderSubTypes.filter(o => o.OrderSubTypeShortName === allOrderSubTypeElements[i].value);
                    if(currentCountryOrderSubType[0].OrderSubTypeShortName === NFR_ORDER_SUBTYPE &&
                        $('input[name="OrderSelection"]:checked').prop('id') === GUEST_ORDER_TYPE) continue;

                    if(showRadio) {
                        $orderSubTypeRadio.parent().show();
                    }

                    $orderSubTypeRadio.parent().find('p').text(currentCountryOrderSubType[0].OrderSubTypeDescription);
                    if(currentCountrySupportedOrderSubTypes.length <= 1 || allOrderSubTypeElements[i].value === CURR_ORDERSUBTYPE) {
                        $orderSubTypeRadio.trigger('click');
                        showClearAlerts(currentCountryRadioValue, allOrderSubTypeElements[i].value);
                        defaultOrderSubTypeSelected = true;
                    } else if(!defaultOrderSubTypeSelected) {
                        $orderSubTypeRadio.trigger('click');
                        showClearAlerts(currentCountryRadioValue, allOrderSubTypeElements[i].value);
                        defaultOrderSubTypeSelected = true;
                    }
                } else {
                    $('#OrderSubTypeRadio' + allOrderSubTypeElements[i].value).parent().hide();
                }
            }

            if(showRadio) {
                if(currentCountrySupportedOrderSubTypes.length > 1) {
                    $('.promotion-ribbon-modal').find('.custom-radio').removeClass('hideRadio');
                    $('.promotion-ribbon-modal').find('.custom-radio').show();
                    $('.promotion-ribbon-modal').find('.custom-radio .custom-control-label').attr('tabindex', '0');
                } else {
                    $('.promotion-ribbon-modal').find('.custom-radio').addClass('hideRadio');
                    $('.promotion-ribbon-modal').find('.custom-radio .custom-control-label').attr('tabindex', '-1');
                }
            }
        } else {
            let firstOrderSubTypeElement = allOrderSubTypeElements[0];
            let $orderSubTypeRadio;
            if(firstOrderSubTypeElement) {
                $orderSubTypeRadio = $('#OrderSubTypeRadio' + firstOrderSubTypeElement.value);
            }
            if($orderSubTypeRadio && $orderSubTypeRadio.length > 0) {
                if(showRadio) {
                    $orderSubTypeRadio.parent().show();
                }
                $orderSubTypeRadio.trigger('click');
                showClearAlerts(currentCountryRadioValue, allOrderSubTypeElements[0].value);
                defaultOrderSubTypeSelected = true;
            }
        }
    }
}

async function checkForRcBetaFeatureToggle() {
    let $rcAlert = $('.alert--rcBetaFeatureNotParticipating');
    $rcAlert.hide();
    let $catalogSelector = $('.catalogSelectorModal');

    if(!$catalogSelector || $catalogSelector.length === 0) return;

    catalogSelectorData = $catalogSelector.data('catalog-selector');

    if(!catalogSelectorData) return;

    var allowedSC10Markets = catalogSelectorData.AllowedSC10Markets;

    var currentCountry = $("input[name='Region']:checked").val();

    let selectedOrderType = $('input[name="OrderSelection"]:checked').prop('id');
    var shouldCheckForRcBetaFeatureToggle = selectedOrderType === RECOMMENDED_CART_ORDER_TYPE;

    if(!shouldCheckForRcBetaFeatureToggle) return;

    let isDisallowedCreateRecommendedCartOption = false;
    if(catalogSelectorData.AllowedMarketsForUser) {
        let allowedMarket = catalogSelectorData.AllowedMarketsForUser.find(m => m.Value === currentCountry);
        if(allowedMarket) {
            isDisallowedCreateRecommendedCartOption = allowedMarket.IsDisallowedCreateRecommendedCartOption;
        }
    }

    if(allowedSC10Markets && allowedSC10Markets.length > 0) {
        // selected market is not sc10 supported market
        var currMarket = allowedSC10Markets.filter(m => m === currentCountry);
        shouldCheckForRcBetaFeatureToggle = !currMarket || currMarket.length === 0 || isDisallowedCreateRecommendedCartOption;
    }

    if(!shouldCheckForRcBetaFeatureToggle) return;

    if(catalogSelectorData.IsSitecoreRecommendedCartFeatureEnabled || isDisallowedCreateRecommendedCartOption) {
        // feature on but not supported sc10 market
        $rcAlert.show();
    } else {
        // feature off
        $rcAlert.hide();
    }
}
